import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-5 pb-2 px-5 d-flex justify-space-between flex-wrap width-small-screen" }

import {reactive} from 'vue';
import Icon from "@/components/Icons/Icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonTab',
  props: {
  modelValue: {
    type: Object,
  },
  colour: {
    type: String,
    default: 'primary',
  },
  bgColour: {
    type: String,
    default: 'transparent',
  },
  tabs: {
    type: Array,
    default: () => [],
  },
  dark: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const state = reactive({
  modelValue: props.modelValue,
  tabs: props.tabs,
  dark: props.dark,
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, { color: __props.bgColour }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
          return (_openBlock(), _createElementBlock("div", {
            key: tab.name,
            class: "width-small-screen"
          }, [
            _createVNode(_component_v_btn, {
              class: _normalizeClass([state.modelValue.method == 'in-person' ? 'text-white' : '', "b-round-20 width-small-screen"]),
              color: state.modelValue.name == tab.name ? __props.colour : '',
              disabled: tab.disabled,
              variant: state.modelValue.name == tab.name ? 'flat' : 'text',
              onClick: ($event: any) => {state.modelValue = tab;emit('update:modelValue', state.modelValue)}
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass([__props.dark && state.modelValue.name == tab.name  ? 'text-white' : '', "font-size-12-600 text-capitalize d-flex align-center ga-1"])
                }, [
                  _createVNode(Icon, {
                    color: state.modelValue.name == tab.name ? tab.colour : __props.colour,
                    icon: tab.icon
                  }, null, 8, ["color", "icon"]),
                  _createTextVNode(" " + _toDisplayString(tab.name), 1)
                ], 2)
              ]),
              _: 2
            }, 1032, ["class", "color", "disabled", "variant", "onClick"])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["color"]))
}
}

})